import { NavLink, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck } from "lucide-react";
import { Brand } from "@/components/layout/Brand";
import { Button } from "@/components/ui/button";
import { ThemeToggle } from "@/components/layout/ThemeToggle";
import { Container } from "@/components/layout/Container";
import { useAuth } from "@/hooks/useAuth";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export function TopBar() {
  const navigate = useNavigate();
  const { email, signOut } = useAuth();
  // Admin entry point is rendered ONLY for platform admins, so non-admins
  // never see a way in. AdminLayout + the backend re-check the role anyway.
  const me = useCurrentUser();
  const isAdmin = me.data?.role_id === "SUPER_ADMIN";

  return (
    <header className="sticky top-0 z-30 border-b border-border bg-bg/85 backdrop-blur-md pt-safe">
      <Container size="full" className="flex h-14 items-center justify-between">
        <Brand to="/dashboard" />
        <div className="flex items-center gap-1 sm:gap-2">
          {email ? (
            <span className="hidden md:inline text-sm text-text-muted truncate max-w-[200px]">
              {email}
            </span>
          ) : null}
          {isAdmin ? (
            <Button
              asChild
              variant="ghost"
              size="icon"
              aria-label="Admin console"
              title="Admin console"
              className="rounded-full"
            >
              <NavLink to="/admin">
                <ShieldCheck className="h-[1.05rem] w-[1.05rem]" />
              </NavLink>
            </Button>
          ) : null}
          <ThemeToggle />
          <Button
            variant="ghost"
            size="icon"
            aria-label="Sign out"
            title="Sign out"
            className="rounded-full"
            onClick={async () => {
              await signOut();
              navigate("/auth/login", { replace: true });
            }}
          >
            <LogOut className="h-[1.05rem] w-[1.05rem]" />
          </Button>
        </div>
      </Container>
    </header>
  );
}
